import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isBrowser } from '@migros/msrc-browser';
import { FIRST_PAGE } from './config';
export const getCurrentUrlSearchParams = () => {
  // eslint-disable-next-line
  return new URLSearchParams(isBrowser() ? window.location.search : '');
};
export const extractPageFromCurrentUrl = pageParamName => {
  const page = parseInt(getCurrentUrlSearchParams().get(pageParamName) || '1', 10);
  return page > 0 ? page : 1;
};
export const isPageResetRequired = (currentPage, previousPage) => {
  // page reset is required as soon as a rerendering occurs without a page change (ie. filter options change)
  // eslint-disable-next-line
  return !hasPageChanged(currentPage, previousPage) && !isFirstPage(currentPage);
};
export const hasPageChanged = (currentPage, previousPage) => {
  return previousPage === undefined || previousPage !== currentPage;
};
export const isFirstPage = currentPage => {
  return currentPage === FIRST_PAGE;
};
export const isPaginationEnabled = paginationOptions => {
  return paginationOptions && !paginationOptions.disabled;
};
export const decorateQueryParamsWithPage = (queryParams, page = 1, articlesPerPage, paginationOptions) => {
  const limit = articlesPerPage;
  const offset = (page - 1) * articlesPerPage;
  if (paginationOptions && paginationOptions.disabled) {
    return _objectSpread({}, queryParams);
  }
  return _objectSpread(_objectSpread({}, queryParams), {}, {
    limit,
    offset
  });
};